const membersProfile = {

	/**
	 * Store the reef app for this component.
	 *
	 * @type {object}
	 */
	app: undefined,


	/**
	 * Initialize the component.
	 */
	init: function() {

		const $comp = document.getElementById( 'profile-edit' );

		// Quit because there's no space to edit the profile.
		if ( !$comp ) {
			return;
		}

		membersProfile.app = new Reef(
			$comp,
			{
				data: members.app.data,
				template: membersProfile.template,
				attachTo: [ members.app ]
			}
		);

		members.app.render();

		$comp.addEventListener( 'click', membersProfile.click );

	},


	/**
	 * Define the template for the component.
	 *
	 * @param {object} props The component properties.
	 * @return {string}
	 */
	template: function( props ) {

		const user = props.member;

		// No user so display a logged out message.
		if ( !user ) {
			return `<div class="p4 bg-red b-br2 f-fw500"><a href="/join/">Login or Join Brush Ninja</a> to access this page.</div>`;
		}

		// Check email is defined.
		let user_email = user.email;
		if ( undefined === user_email ) {
			user_email = '';
		}

		// Logged in so display a form for editing the profile.
		return `
		<form id="signup-form" method="POST">
			<label for="profile-username">Login Username</label>
			<input id="profile-username" name="profile-username" disabled type="text" value="${sanitize.attr( user.username )}">

			<label for="profile-email">Email <small>Only used to reset your password</small></label>
			<input id="profile-email" name="profile-email" type="email" value="${sanitize.attr( user_email )}" required minLength="6">

			<fieldset>
				<legend>Update Password</legend>
				<label for="profile-password">Password</label>
				<input id="profile-password" name="profile-password" type="password" placeholder="Password">

				<label for="new-profile-password">New Password</label>
				<input id="new-profile-password" name="new-profile-password" type="password" placeholder="New Password">
			</fieldset>

			<div id="edit-profile-error" class="p3 bg-red b-br2 f-fw600 m-b4 display-none"></div>

			<input type="submit" id="submit-profile" value="Update Profile" class="button">
		</form>
		`;

	},


	/**
	 * Update the user data.
	 *
	 * @return {void}
	 */
	update: function() {

		const input_email = document.getElementById( 'profile-email' );
		const input_password = document.getElementById( 'profile-password' );
		const input_new_password = document.getElementById( 'new-profile-password' );

		const currentPassword = input_password.value;
		const newPassword = input_new_password.value;
		const email = input_email.value;

		let settings = {};
		settings.email = email;

		if ( newPassword || currentPassword ) {
			settings.currentPassword = currentPassword;
			settings.newPassword = newPassword;
		}

		userbase.updateUser( settings )
			.then(
				() => {
					// Is this needed?
					// members.app.render();

					alert( 'Your profile has been updated.' );
				}
			)
			.catch(
				( e ) => {
					members.errorDisplay( e, 'edit-profile-error' );
				}
			);

	},


	/**
	 * Click action for the component.
	 *
	 * @param {object} e Event.
	 * @return {void}
	 */
	click: function( e ) {

		const target = e.target;
		const id = target.id;

		if ( 'submit-profile' === id ) {

			e.preventDefault();
			membersProfile.update();

			members.disableButton( target );

		}

	},

};